import {
  Checkbox,
  Field,
  FieldsContainer,
  Form,
  TextField,
  useDeepEffect,
  useForm,
  Validator,
} from "common";
import { FakeEvent } from "common/types";

export interface BillingData {
  first_name: string;
  last_name: string;
  country: string;
  postcode: string;
  city: string;
  street_address: string;
  phone: string;
  email: string;
  // Opcionális mezők
  is_company?: boolean;
  company_name?: string;
  vat_number?: string;
  apartment?: string;
  county?: string;
}

export interface BillingDataInputProps {
  id?: string;
  value?: Partial<BillingData>;
  onChange?: (value: FakeEvent<BillingData>) => void;
  disabled?: boolean;
  error?: any;
}

export default function BillingDataInput({
  value,
  onChange,
  disabled = false,
  error,
}: BillingDataInputProps) {
  const isCompany = !!value?.is_company;

  const form = useForm<Partial<BillingData> | undefined, any>({
    defaultValues: value,
    rules: {
      first_name: Validator.rule.string().required(),
      last_name: Validator.rule.string().required(),
      country: Validator.rule.string().required(),
      postcode: Validator.rule.string().required(),
      city: Validator.rule.string().required(),
      street_address: Validator.rule.string().required(),
      phone: Validator.rule.string().required(),
      email: Validator.rule
        .string()
        .email({ tlds: { allow: false } })
        .required(),
      ...(isCompany && {
        company_name: Validator.rule.string().required(),
        vat_number: Validator.rule.string().required(),
      }),
    },
    afterChange: newItem => {
      onChange && onChange({ target: { value: newItem || ({} as any) } });
    },
  });

  useDeepEffect(() => {
    form.setItem(value || {});
  }, [value]);

  return (
    <Form
      item={form.item}
      onChange={form.onChange}
      disabled={disabled}
      requiredFields={form.getRequiredFields()}
      errors={error}
      translationCategory="Booking.attributes"
    >
      <FieldsContainer>
        <Field fullWidth>
          <Checkbox id="is_company" />
        </Field>
        <Field half>
          <TextField id="first_name" />
        </Field>
        <Field half>
          <TextField id="last_name" />
        </Field>
        {isCompany && (
          <>
            <Field fullWidth>
              <TextField id="company_name" />
            </Field>
            <Field fullWidth>
              <TextField id="vat_number" />
            </Field>
          </>
        )}
        <Field fullWidth>
          <TextField id="country" />
        </Field>
        <Field half>
          <TextField id="postcode" />
        </Field>
        <Field half>
          <TextField id="city" />
        </Field>
        <Field fullWidth>
          <TextField id="county" />
        </Field>
        <Field fullWidth>
          <TextField id="street_address" />
        </Field>
        <Field fullWidth>
          <TextField id="apartment" />
        </Field>
        <Field half>
          <TextField id="phone" />
        </Field>
        <Field half>
          <TextField id="email" />
        </Field>
      </FieldsContainer>
    </Form>
  );
}
